import { ExperienceTemplateRendererComponentLibrary } from 'experience-template-renderer-react';

import { VoiceOfTheCustomer } from '@shared-ui/customer-voice-of-the-customer';

import { UitkComponent } from '../../search/template-components/uitk-component';

import { SharedUiSingleOfferPropertyLevelOffersCardWrapper } from 'components/infosite/shared-ui/offers/single-offer-property-level-card-wrapper';
import { AboutThisPropertyWrapper } from './about-property-wrapper';
import { ActivityRecommendationsWrapper } from 'components/infosite/activity-recommendations';
import { IntersectionTrackerWrapper } from './intersection-wrapper';
import { LayoutGrid } from './layout-grid';
import { LayoutGridItem } from './layout-grid-item';
import { MesoSideRail } from '../../meso/meso-side-rail';
import { PropertyAboutThisPropertyDirectFeedbackWrapper } from './property-direct-feedback-wrapper';
import { PropertyBottomCarouselWrapper } from './property-bottom-carousel-wrapper';
import { PropertyContactHostWrapper } from './property-contact-host-wrapper';
import { PropertyGallery } from 'components/infosite/property-details/property-gallery';
import { PropertyLevelMessages } from './property-messages';
import { PropertyNavigation } from './property-navigation';
import { PropertySpacesExperiment } from '../experiments/property-spaces-experiment';
import { PropertySummaryBackLinkWrapper } from '../property-summary-backlink-wrapper';
import { PropertyTopCarouselWrapper } from './property-top-carousel-wrapper';
import { RoomsAndRates } from 'components/infosite/rooms-and-rates';
import { SharedUiAboutThisPropertyWrapper } from '../shared-ui/details/about-this-property-wrapper';
import { SharedUiAmenityDescriptionWrapper } from 'components/infosite/shared-ui/details/amenity-description-wrapper';
import { SharedUiGexWrapper } from './gex-module-wrapper';
import { SharedUiImportantInfoWrapper } from 'components/infosite/shared-ui/details/important-info-wrapper';
import { SharedUiPoliciesWrapper } from 'components/infosite/shared-ui/details/policies-wrapper';
import { SharedUiPropertyFaqWrapper } from 'components/infosite/shared-ui/details/frequently-asked-questions-wrapper';
import { SharedUiPropertyHighlightWrapper } from 'components/infosite/shared-ui/offers/property-highlight-wrapper';
import { SharedUiPropertyHostProfileWrapper } from '../shared-ui/details/property-host-profile-wrapper';
import { SharedUiPropertyLegalDisclaimerWrapper } from '../shared-ui/offers/property-legal-disclaimer-wrapper';
import { SharedUiPropertyLevelOffersCardWrapper } from 'components/infosite/shared-ui/offers/property-level-card-wrapper';
import { SharedUiPropertyLevelOffersMessageWrapper } from 'components/infosite/shared-ui/offers/property-level-messages-wrapper';
import { SharedUiPropertyReviewsWrapper } from 'components/infosite/shared-ui/reviews/shared-ui-property-reviews-wrapper';
import { SharedUiSimilarPropertiesWrapper } from 'components/infosite/shared-ui/details/shared-ui-similar-properties';
import { SharedUiSpaceDetailsWrapper } from 'components/infosite/shared-ui/offers/space-details-wrapper';
import { SharedUiSpecialFeaturesWrapper } from 'components/infosite/shared-ui/details/special-features-wrapper';
import { SharedUiSummaryWrapper } from '../shared-ui/details/summary-wrapper';
import { SharedUiTripSummaryWrapper } from 'components/infosite/shared-ui/offers/trip-summary-wrapper';
import { SharedUiWhatsAroundWrapper } from 'components/infosite/shared-ui/details/whats-around-wrapper';
import { SideRailRegion } from '../../search/template-components/side-rail-region';
import { SingleOfferPriceWrapper } from './single-offer-price';
import { SingleOfferSummaryWrapper } from './property-summary-wrapper';
import { SpaceDetailsWrapper } from './space-details-wrapper';
import { StickyBookBar } from './sticky-book-bar';

export const componentLibrary: ExperienceTemplateRendererComponentLibrary = new Map()
  .set('LayoutGrid', LayoutGrid)
  .set('SpaceDetailsWrapper', SpaceDetailsWrapper)
  .set('PropertyAboutThisPropertyDirectFeedbackWrapper', PropertyAboutThisPropertyDirectFeedbackWrapper)
  .set('AboutThisPropertyWrapper', AboutThisPropertyWrapper)
  .set('SharedUiPropertyHostProfileWrapper', SharedUiPropertyHostProfileWrapper)
  .set('SharedUiAmenityDescriptionWrapper', SharedUiAmenityDescriptionWrapper)
  .set('SharedUiImportantInfoWrapper', SharedUiImportantInfoWrapper)
  .set('SharedUiPoliciesWrapper', SharedUiPoliciesWrapper)
  .set('SharedUiPropertyReviewsWrapper', SharedUiPropertyReviewsWrapper)
  .set('IntersectionTrackerWrapper', IntersectionTrackerWrapper)
  .set('SingleOfferSummaryWrapper', SingleOfferSummaryWrapper)
  .set('SharedUiWhatsAroundWrapper', SharedUiWhatsAroundWrapper)
  .set('SharedUiPropertyLevelOffersMessageWrapper', PropertyLevelMessages)
  .set('SharedUiSimilarPropertiesWrapper', SharedUiSimilarPropertiesWrapper)
  .set('PropertyTopCarouselWrapper', PropertyTopCarouselWrapper)
  .set('PropertyBottomCarouselWrapper', PropertyBottomCarouselWrapper)
  .set('SharedUiStickyBookBarWrapper', StickyBookBar)
  .set('ActivityRecommendationsWrapper', ActivityRecommendationsWrapper)
  .set('SingleOfferPriceWrapper', SingleOfferPriceWrapper)
  .set('PropertyGallery', PropertyGallery)
  .set('PropertyNavigation', PropertyNavigation)
  .set('LayoutGridItem', LayoutGridItem)
  .set('SharedUiPropertyFaqWrapper', SharedUiPropertyFaqWrapper)
  .set('RoomsAndRates', RoomsAndRates)
  .set('VoiceOfTheCustomer', VoiceOfTheCustomer)
  .set('MultiOfferSummary', SharedUiSummaryWrapper)
  .set('GexModule', SharedUiGexWrapper)
  .set('PropertyHighlight', SharedUiPropertyHighlightWrapper)
  .set('PropertyLegalDisclaimer', SharedUiPropertyLegalDisclaimerWrapper)
  .set('PropertyLevelOffersMessage', SharedUiPropertyLevelOffersMessageWrapper)
  .set('SpaceDetails', SharedUiSpaceDetailsWrapper)
  .set('TripSummary', SharedUiTripSummaryWrapper)
  .set('SharedUiAboutThisPropertyWrapper', SharedUiAboutThisPropertyWrapper)
  .set('SharedUiSpecialFeaturesWrapper', SharedUiSpecialFeaturesWrapper)
  .set('UitkComponent', UitkComponent)
  .set('SideRailRegion', SideRailRegion)
  .set('MesoSideRail', MesoSideRail)
  .set('PropertySummaryBackLinkWrapper', PropertySummaryBackLinkWrapper)
  .set('PropertySpacesExperiment', PropertySpacesExperiment)
  .set('SharedUiPropertyLevelOffersCardWrapper', SharedUiPropertyLevelOffersCardWrapper)
  .set('SharedUiSingleOfferPropertyLevelOffersCardWrapper', SharedUiSingleOfferPropertyLevelOffersCardWrapper)
  .set('SharedUiContactHostWrapper', PropertyContactHostWrapper);
